import { del, get, post, put } from "../../helpers/utils/http-client";
import { APPS_ENDPOINT } from "../../consts/api-endpoints";

export async function saveAgentCoreSettings(appId, data) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/agent/core-settings`, data);
    } catch (err) {
        console.debug('saveAgentCoreSettings failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function getAgentCoreSettings(appId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/agent/core-settings`);
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getAgentCoreSettings failed cause', err.message, err.code);
        return null;
    }
}

export async function getAgentActions(appId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/agent/actions`);
        if (status !== 200) {
            return {
                data: []
            };
        }
        return response;
    } catch (err) {
        console.debug('getAgentActions failed cause', err.message, err.code);
        return {
            data: []
        };
    }
}

export async function getAgentAction(appId, name) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/agent/actions/${name}`);
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getAgentAction failed cause', err.message, err.code);
        return null;
    }
}

export async function saveAgentActionSettings(appId, action) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/agent/actions`, action);
    } catch (err) {
        console.debug('saveAgentActionSettings failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function runtimeExecute(appId, sessionId, inputText) {
    try {
        const { response, status } = await post(`${APPS_ENDPOINT}/${appId}/prompt/runtime/execute`,
            {
                sessionId,
                inputText
            });
        if (status !== 200) {
            return [];
        }
        return response;
    } catch (err) {
        console.debug('runtimeExecute failed cause', err.message, err.code);
        return [];
    }
}

export async function deleteAgentActionSettings(appId, actionId) {
    try {
        return await del(`${APPS_ENDPOINT}/${appId}/agent/actions/${actionId}`);
    } catch (err) {
        console.debug('deleteAgentActionSettings failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function disableAgentActionSettings(appId, actionId, deactivate) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/agent/actions/${actionId}/disable`, { deactivate });
    } catch (err) {
        console.debug('disableAgentActionSettings failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function setScheduleOnlyAgentActionSettings(appId, actionId, scheduleOnly) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/agent/actions/${actionId}/schedule-only`, { scheduleOnly });
    } catch (err) {
        console.debug('setScheduleOnlyAgentActionSettings failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function getPromptConfigInstructions(appId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/instructions`);
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getPromptConfigInstructions failed cause', err.message, err.code);
        return null;
    }
}

export async function createPromptConfigInstructions(appId, data) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/prompt-config/instructions`, data);
    } catch (err) {
        console.debug('createPromptConfigInstructions failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function updatePromptConfigInstructions(appId, data) {
    try {
        return await put(`${APPS_ENDPOINT}/${appId}/prompt-config/instructions`, data);
    } catch (err) {
        console.debug('updatePromptConfigInstructions failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function getPromptConfigTools(appId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/tools`);
        if (status !== 200) {
            return [];
        }
        return response?.data ?? response ?? [];
    } catch (err) {
        console.debug('getPromptConfigTools failed cause', err.message, err.code);
        return [];
    }
}

export async function getPromptConfigTool(appId, toolId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/tools/${toolId}`);
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getPromptConfigTool failed cause', err.message, err.code);
        return null;
    }
}

export async function createPromptConfigTool(appId, data) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/prompt-config/tools`, data);
    } catch (err) {
        console.debug('createPromptConfigTool failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function updatePromptConfigTool(appId, toolId, data) {
    try {
        return await put(`${APPS_ENDPOINT}/${appId}/prompt-config/tools/${toolId}`, data);
    } catch (err) {
        console.debug('updatePromptConfigTool failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function deletePromptConfigTool(appId, toolId) {
    try {
        return await del(`${APPS_ENDPOINT}/${appId}/prompt-config/tools/${toolId}`);
    } catch (err) {
        console.debug('deletePromptConfigTool failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}
// ─── Skills ───────────────────────────────────────────────────────────────────

export async function getPromptConfigSkills(appId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/skills`);
        if (status !== 200) {
            return [];
        }
        return response?.data ?? response ?? [];
    } catch (err) {
        console.debug('getPromptConfigSkills failed cause', err.message, err.code);
        return [];
    }
}

export async function getPromptConfigSkill(appId, skillId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/skills/${skillId}`);
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getPromptConfigSkill failed cause', err.message, err.code);
        return null;
    }
}

export async function createPromptConfigSkill(appId, data) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/prompt-config/skills`, data);
    } catch (err) {
        console.debug('createPromptConfigSkill failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function updatePromptConfigSkill(appId, skillId, data) {
    try {
        return await put(`${APPS_ENDPOINT}/${appId}/prompt-config/skills/${skillId}`, data);
    } catch (err) {
        console.debug('updatePromptConfigSkill failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function deletePromptConfigSkill(appId, skillId) {
    try {
        return await del(`${APPS_ENDPOINT}/${appId}/prompt-config/skills/${skillId}`);
    } catch (err) {
        console.debug('deletePromptConfigSkill failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

// ─── MCP servers ──────────────────────────────────────────────────────────────

export async function getPromptConfigMcpServers(appId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/mcp-servers`);
        if (status !== 200) {
            return [];
        }
        return response?.data ?? response ?? [];
    } catch (err) {
        console.debug('getPromptConfigMcpServers failed cause', err.message, err.code);
        return [];
    }
}

export async function getPromptConfigMcpServer(appId, serverId) {
    try {
        const { response, status } = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/mcp-servers/${serverId}`);
        if (status !== 200) {
            return null;
        }
        return response;
    } catch (err) {
        console.debug('getPromptConfigMcpServer failed cause', err.message, err.code);
        return null;
    }
}

export async function createPromptConfigMcpServer(appId, data) {
    try {
        return await post(`${APPS_ENDPOINT}/${appId}/prompt-config/mcp-servers`, data);
    } catch (err) {
        console.debug('createPromptConfigMcpServer failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function updatePromptConfigMcpServer(appId, serverId, data) {
    try {
        return await put(`${APPS_ENDPOINT}/${appId}/prompt-config/mcp-servers/${serverId}`, data);
    } catch (err) {
        console.debug('updatePromptConfigMcpServer failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}

export async function deletePromptConfigMcpServer(appId, serverId) {
    try {
        return await del(`${APPS_ENDPOINT}/${appId}/prompt-config/mcp-servers/${serverId}`);
    } catch (err) {
        console.debug('deletePromptConfigMcpServer failed cause', err.message, err.code);
        return { response: err.displayError, status: err.code };
    }
}
